import { runCubeTest } from "./cubeTest";
import { runModelViewer } from "./modelViewer"

// runCubeTest();

runModelViewer();